import { useForm } from 'react-hook-form';
import {
  EditAdminProfileFormValues,
  editAdminProfileFormResolver,
} from './schema';

export type EditAdminProfileUseForm = ReturnType<
  typeof useForm<EditAdminProfileFormValues>
>;

export const useEditAdminProfileForm = (
  defaultValues?: Partial<EditAdminProfileFormValues>,
) => {
  const editAdminProfileForm = useForm<EditAdminProfileFormValues>({
    resolver: editAdminProfileFormResolver,
    defaultValues: {
      firstname: '',
      lastname: '',
      ...defaultValues,
      picture: defaultValues?.picture ?? null,
      file: defaultValues?.file ?? null,
    },
  });

  return { editAdminProfileForm };
};
